import { Media, MediaBody, MediaLeft } from 'foundations-components/transitional/components/Media';
import AvatarIcon from './AvatarIcon';
import { Text } from 'foundations-components/components/Text';
import { useCardContextValue } from '../state/CardContext';
import { getRecordLabel } from '../utils/subject';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MiniRecordAvatarAndName = () => {
  var _objectTypeDefinition;
  const {
    asyncData: {
      subjectResult,
      objectTypeDefinitionResult
    }
  } = useCardContextValue();
  const subject = subjectResult.data;
  const objectTypeDefinition = (_objectTypeDefinition = objectTypeDefinitionResult.data) === null || _objectTypeDefinition === void 0 ? void 0 : _objectTypeDefinition.objectTypeDefinition;
  if (!subject || !objectTypeDefinition) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Media, {
    spacing: "extra-small",
    align: "center",
    children: [/*#__PURE__*/_jsx(MediaLeft, {
      children: /*#__PURE__*/_jsx(AvatarIcon, {
        size: "small"
      })
    }), /*#__PURE__*/_jsx(MediaBody, {
      children: /*#__PURE__*/_jsx(Text, {
        typography: "body-125",
        children: /*#__PURE__*/_jsx(TruncateString, {
          children: getRecordLabel(objectTypeDefinition, subject)
        })
      })
    })]
  });
};
export default MiniRecordAvatarAndName;